/** localStorage for Q7.3 — OOS experience (Yes / No). */
export const Q7_3_STORAGE_KEY = 'ploomsurvey:q7_3';

export type Q7_3Answers = {
  oos: 'Yes' | 'No';
};

export function readQ7_3Answers(): Q7_3Answers | null {
  try {
    const raw = localStorage.getItem(Q7_3_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const v = (o as { oos?: unknown }).oos;
    if (v === 'Yes' || v === 'No') {
      return { oos: v };
    }
    return null;
  } catch {
    return null;
  }
}

export function writeQ7_3Answers(data: Q7_3Answers): void {
  try {
    localStorage.setItem(Q7_3_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearQ7_3Answers(): void {
  try {
    localStorage.removeItem(Q7_3_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isQ7_3Complete(): boolean {
  return readQ7_3Answers() != null;
}
